import Keyboard from './src/keyboard-combined';
export default Keyboard;